import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import ApiList from "services/apiList";
import { currentUser } from "services/users/authSlice";
import { ESService } from "services/esService";
import Teachers from "./Teachers";
import Courses from "./Courses";
import ChooseLesson from "./ChooseLesson";
import LessonTypes from "./LessonTypes";
import Loader from "components/loader";

export default function ScheduleModal(props) {
  const { setShowModal, getScheduleList,lessonTypes } = props;
  const mount = useRef(true);
  var user = useSelector(currentUser);
  const [loading, setLoading] = useState(false);
  const [lessonType, setLessonType] = useState({});
  const [lesson, setLesson] = useState({});
  const [lessons, setLessons] = useState([]);
  const [teacher, setTeacher] = useState({});
  const [teachers, setTeachers] = useState([]);
  const [course, setCourse] = useState({});
  const [courses, setCourses] = useState([]);

  const [stepIndex, setStepIndex] = useState(0);
  var steps = [
    <LessonTypes
      setShowModal={setShowModal}
      value={lessonType}
      data={lessonTypes}
      handleSubmit={(index) => {
        setLoading(true);
        const token = user.token;
        const es = new ESService(token);
        setLessonType(lessonTypes[index]);
        es.get(
          ApiList.scheduleLessonUrl,
          "lesson_type=" + lessonTypes[index].id
        ).then((json) => {
          if (json["status"]) {
            setLessons(json["data"]);
            setStepIndex(stepIndex + 1);
            setLoading(false);
          } else {
            setShowModal(false);
          }
        });
      }}
    />,

    <ChooseLesson
      setShowModal={setShowModal}
      value={lesson}
      data={lessons}
      handleSubmit={(index) => {
        setTeachers(lessons[index] ? lessons[index].teachers : []);
        setCourses(lessons[index] ? lessons[index].courses : []);
        setLesson(lessons[index].lesson);
        setStepIndex(stepIndex + 1);
      }}
      back={() => {
        if (stepIndex > 0) {
          setStepIndex(stepIndex - 1);
        }
      }}
    />,
    <Teachers
      setShowModal={setShowModal}
      value={teacher}
      data={teachers}
      handleSubmit={(index) => {
        setTeacher(teachers[index]);
        setStepIndex(stepIndex + 1);
      }}
      back={() => {
        if (stepIndex > 0) {
          setStepIndex(stepIndex - 1);
        }
      }}
    />,
    <Courses
      setShowModal={setShowModal}
      value={course}
      data={courses}
      handleSubmit={(index) => {
        setCourse(courses[index]);
        const token = user.token;
        const es = new ESService(token);
        es.post(ApiList.scheduleDetailUrl, {
          schedule: props.schedule.id,
          lesson: lesson.id,
          teacher: teacher.id,
          course: courses[index].id,
          classroom: props.room,
          day: props.day,
          time: props.time,
        }).then((json) => {
          if (json["status"]) {
            setShowModal(false);
            getScheduleList();
          }
        });
      }}
      back={() => {
        if (stepIndex > 0) {
          setStepIndex(stepIndex - 1);
        }
      }}
    />,
  ];

  useEffect(() => {
    const fetchData = async () => {
      if (mount.current) {
        mount.current = false;
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none ">
            <div className="relative my-6 mx-auto w-auto max-w-3xl">
              <div className="relative flex w-full flex-col rounded-lg border-0 bg-white p-10 shadow-lg outline-none focus:outline-none">
                {steps[stepIndex]}
              </div>
            </div>
          </div>
          <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
        </div>
      )}
    </div>
  );
}
